<template>
  <div ref="echarts" class="echarts-sub" />
</template>
<script>
import * as echarts from 'echarts'
export default {
  props: {
    option: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      myChart: null
    }
  },
  watch: {
    option: {
      // 监听的对象
      deep: true, // 深度监听设置为 true
      handler: function() {
        this.initEcharts()
      }
    }
  },
  mounted() {
    var chartDom = this.$refs.echarts
    this.myChart = echarts.init(chartDom, 'light')
    const parentDom = chartDom.parentNode
    const style = window.getComputedStyle(parentDom, null)
    // eslint-disable-next-line no-unused-expressions
    style.getPropertyValue('position') === 'relative' ? chartDom.classList.add('echarts-sub-position') : ''
    this.resize()
    this.initEcharts()
  },
  methods: {
    initEcharts() {
      this.myChart.clear()
      this.$nextTick(() => {
        this.myChart.setOption(this.option)
      })
    },
    resize() {
      this.$nextTick(() => {
        this.myChart.resize()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.echarts-sub {
  min-height: 1px;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  // position: absolute;
}
.echarts-sub-position {
  position: absolute;
}
</style>
